import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ROLLEN_NAMEN, type MeinProjekt } from '@beholder/shared';
import { api } from '../api';
import { useIch } from '../sitzung';
import { Symbol } from '../symbole';
import { Dialog, Eingabe, Feld, Knopf, Laden, Leer, Meldung, Textfeld, useAktion, useDaten } from '../ui';
import { WEB_MODULE } from '../modul';

export function Projekte() {
  const ich = useIch();
  const { daten, fehler, laedt } = useDaten(() => api.get<MeinProjekt[]>('/api/projekte'));
  const [neu, setNeu] = useState(false);
  const [archiv, setArchiv] = useState(false);
  const liste = (daten ?? []).filter((p) => p.archiviert === archiv);
  const archivZahl = (daten ?? []).filter((p) => p.archiviert).length;

  return (
    <div className="seite">
      <header className="seiten-kopf">
        <h1>{archiv ? 'Archivierte Projekte' : 'Projekte'}</h1>
        <div className="reihe">
          {(archivZahl > 0 || archiv) && (
            <Knopf art="leise" onClick={() => setArchiv(!archiv)}>
              {archiv ? 'Aktive zeigen' : `Archiv (${archivZahl})`}
            </Knopf>
          )}
          {ich.darfProjekte && (
            <Knopf art="haupt" onClick={() => setNeu(true)}>
              {Symbol.plus} Neues Projekt
            </Knopf>
          )}
        </div>
      </header>
      <Meldung>{fehler}</Meldung>
      {laedt && !daten && <Laden />}
      {daten && liste.length === 0 && (
        <Leer titel={archiv ? 'Kein Projekt im Archiv' : 'Noch keine Projekte'}>
          {!archiv && (ich.darfProjekte ? 'Lege dein erstes Projekt an.' : 'Sobald dich jemand einlädt, erscheint das Projekt hier.')}
        </Leer>
      )}
      <div className="raster">
        {liste.map((p) => (
          <Link key={p.id} to={`/p/${p.id}`} className="projekt-kachel">
            <strong>{p.name}</strong>
            {p.beschreibung && <span className="leise zeilen-2">{p.beschreibung}</span>}
            <span className="marke">{p.rolle ? ROLLEN_NAMEN[p.rolle] : 'Admin'}</span>
          </Link>
        ))}
      </div>
      {!archiv && WEB_MODULE.some((m) => m.Startkarte) && (
        <div className="raster">
          {WEB_MODULE.map((m) => m.Startkarte && <m.Startkarte key={m.id} ich={ich} />)}
        </div>
      )}
      <NeuesProjekt offen={neu} schliessen={() => setNeu(false)} />
    </div>
  );
}

function NeuesProjekt({ offen, schliessen }: { offen: boolean; schliessen(): void }) {
  const [name, setName] = useState('');
  const [beschreibung, setBeschreibung] = useState('');
  const a = useAktion();
  const nav = useNavigate();
  async function senden(e: FormEvent) {
    e.preventDefault();
    const p = await a.ausfuehren(() => api.post<MeinProjekt>('/api/projekte', { name, beschreibung }));
    if (p) nav(`/p/${p.id}`);
  }
  return (
    <Dialog titel="Neues Projekt" offen={offen} schliessen={schliessen}>
      <form onSubmit={senden} className="stapel">
        <Feld titel="Name">
          <Eingabe autoFocus value={name} onChange={(e) => setName(e.target.value)} maxLength={120} />
        </Feld>
        <Feld titel="Beschreibung (optional)">
          <Textfeld rows={4} value={beschreibung} onChange={(e) => setBeschreibung(e.target.value)} />
        </Feld>
        <Meldung>{a.fehler}</Meldung>
        <Knopf art="haupt" type="submit" disabled={!name.trim() || a.laeuft}>
          Anlegen
        </Knopf>
      </form>
    </Dialog>
  );
}
